<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion
        id="accordion"
        [multiple]="false"
        (onOpen)="abrirAcordeon($event)"
      >
        <p-accordionTab
          header="{{ 'PLANESCARGOS.LBL_INFORMACIONGENERAL' | translate }}"
          [selected]="tabSeleccionado === 'INFO'"
        >
          <form
            [formGroup]="formulario"
            (ngSubmit)="onSubmit()"
            novalidate
            id="fCanales"
            name="fCanales"
          >
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ "PLANESCARGOS.LBL_CODIGO" | translate }}</label>
                  <input
                    type="text"
                    pInputText
                    id="codigo"
                    name="nomCodigo"
                    autocomplete="off"
                    formControlName="codigo"
                    maxlength="10"
                    (blur)="validarCodigo()"
                    codigos-reactive
                  />
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.codigo.invalid"
                  >
                    {{ "PLANESCARGOS.LBL_CODIGO" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="codExiste"
                  >
                    {{ "PLANESCARGOS.MSG_CODIGOEXISTE" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ "PLANESCARGOS.LBL_NOMBRE" | translate }}</label>
                  <input
                    type="text"
                    pInputText
                    id="nombre"
                    name="nomNombre"
                    autocomplete="off"
                    formControlName="nombre"
                    [maxlength]="100"
                    capitalize-reactive
                  />
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.nombre.invalid"
                  >
                    {{ "PLANESCARGOS.LBL_NOMBRE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-12 lg:col-12">
                <div class="div-form">
                  <label>{{
                    "PLANESCARGOS.LBL_DESCRIPCION" | translate
                  }}</label>
                  <input
                    type="text"
                    pInputText
                    id="codigo"
                    name="nomCodigo"
                    autocomplete="off"
                    formControlName="descripcion"
                    [maxlength]="500"
                    capitalize-reactive
                  />
                  <div
                    class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.descripcion.invalid"
                  >
                    {{ "PLANESCARGOS.LBL_DESCRIPCION" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{
                    "BTN_CANCELAR" | translate
                  }}</a>
                  <button
                    icon="fa fa-floppy-o"
                    label="{{ 'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton
                  ></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
                  <span>{{ "LBL_GUARDANDO" | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab
          header="{{ 'PLANESCARGOS.LBL_CONCEPTOS' | translate }}"
          [selected]="tabSeleccionado === 'CONCEP'"
          [disabled]="!planCargo"
        >
          <app-planes-cargos-conceptos
            [planCargo]="planCargo"
            (dismiss)="cambiarTabSeleccionado($event)"
            *ngIf="planCargo && planCargo.idPlanCargo"
          ></app-planes-cargos-conceptos>
        </p-accordionTab>
      </p-accordion>
      <div
        class="grid form-footer-buttons"
        *ngIf="planCargo && planCargo.idPlanCargo"
      >
        <div class="form-group col-12">
          <button
            icon="fa fa-arrow-left"
            label="{{ 'BTN_REGRESAR' | translate }}"
            type="button"
            pButton
            (click)="regresar(false)"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
